<template>
	<div class="animate_animated animate__slideInRight">
    <div class="fixed w-full top-0 left-0 z-20">
			<div class=" bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
         <div class="h-1 bg-gradient-to-r from-indigo-500 to-indigo-200"></div>
				<div class="flex items-center px-4 py-4">
					<div class="w-1/2">
						<div class="flex items-center w-full">
							<a  @click="$router.push('/')"><img src="@/assets/back-arrow.svg" alt=""></a>
							<span class="text-base text-content font-medium ml-4">Agreements</span>
						</div>
					</div>
					<div class="w-1/2">
						<div class="flex items-center justify-end">
							<a @click="$router.push('searchagreements')" class="text-main bg-slate-100 p-2.5 rounded-xl"><Filter class="size-5"/></a>
						</div>
					</div>
				</div>
				<div class="flex px-3 pb-3">
					<div class="flex items-strech w-full gap-2">
						<div class="relative w-full">
							<input type="text" @input="e => bsTerm = e.target.value" :value="bsTerm" name="" id="" placeholder="Search Agreements"
								class="border border-inputBorder round-md p-3 w-full z-auto focus:outline-none rounded-xl">
							<button type="button" class="absolute right-0 top-0 m-3" v-if="bsTerm" @click="resetBs">
              <img src="@/assets/close-icon.svg" alt="" class="transform rotate-45"></button>
						</div>

						<div class="bg-primary px-4 flex items-center rounded-xl">
              <button type="button" :disabled="!bsTerm" @click="performBs">
							<img src="@/assets/search-icon-white.svg"   alt="" class=""></button>
						</div>
					</div>
				</div>
			</div>
     
		</div>
		<div class="pt-16 mt-18 min-h-screen bg-gray-50 px-4">
				<!-- Card-List -->
      <span class="result-Text px-3 mt-3 text-sm text-main text-opacity-50 block ">Showing {{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
      <router-link :to="{ name: 'AgreementDetails',  params: {  uuid: ag.uuid } }" v-for="(ag, key) in agreements" :key="key">
			<div class=" bg-white py-3 my-3 rounded-xl ">
				<div class="flex items-center gap-4 px-3">
					<div class="w-1/2">
            <div class="mb-1"  >
              <span class="block text-xs text-slate-500 ">Buyer Name:</span>
							<span class="block text-sm text-slate-800 ">{{ ag.buyer_name || '-'}}</span>
						</div>
            <div class="mb-1" >
              <span class="block text-xs text-slate-500 ">Agreement ID:</span>
							<span class="block text-sm text-slate-800 ">{{ ag.id || '-' }}</span>
						</div>
            <div class="" >
              <span class="block text-xs text-slate-500 ">Property ID:</span>
							<span class="block text-sm text-slate-800 ">{{ ag.property_id || '-' }}</span>
						</div>

			
					</div>

					<div class="w-1/2">
            <div class="mb-1"  >
              <span class="block text-xs text-slate-500 ">Owner Name:</span>
							<span class="block text-sm text-slate-800 ">{{ ag.owner || '-'}}</span>
						</div>
            <div class="mb-1"  >
              <span class="block text-xs text-slate-500 ">Type:</span>
							<span :class="[
    'text-white text-xxs font-medium px-3 py-1 rounded-xl',
    ag.transaction_type === 'Sale'
      ? 'bg-gradient-to-r from-[#00cdac] to-[#62EC14]'
      : ag.transaction_type === 'Rental'
        ? 'bg-gradient-to-r from-indigo-500 to-indigo-300'
        : 'bg-primary'
  ]">{{ag.transaction_type}}</span>
						</div>
             <div class=""  >
              <span class="block text-xs text-slate-500 ">Agmt. Till:</span>
							<span class=" block text-sm text-slate-800">{{ag.agreement_till || '-'}}</span>
						</div>
				
						
						
						<!-- <div class="">
							<span class="text-content text-xs text-opacity-50  mr-1">City</span><span
								class="text-xs text-content font-medium">Pune</span>
						</div> -->
					</div>
				</div>
			</div>
      </router-link>
			<!-- Add Button -->
			<router-link :to="{ name: 'NewAgreement' }" class="fixed bottom-6 right-6 z-50 overflow-hidden group rounded-xl px-4 py-4 flex items-center gap-2 text-white shadow-xl ring-1 ring-white/10 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-500 hover:from-emerald-500 hover:to-teal-500 transition-all duration-300 ease-out hover:scale-105 active:scale-95 shine">
				<img src="@/assets/plus-icon.svg" alt="">
			</router-link>
      <div class="pagination-holder">
              <Pagination v-if="totalPages > 1" v-model="pageNo" :total-pages="totalPages" @update:modelValue="goToPage" />
    </div>
		</div>
	</div>
</template>
<script>
import {paramsFromQuery, prepareAgreementSearchParams} from '@/assets/scripts/utility.js';
import Share from '@/components/icons/Share.vue';
import Filter from '@/components/icons/Filter.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';
import Gmail from '@/components/icons/Gmail.vue';
import RightArrow from '@/components/icons/RightArrow.vue';
export default {
  components: {
    Share,
    Filter,
    WhatsApp,
    Gmail,
    RightArrow
  },
  data () {
    return {
      bsTerm: this.$route.query.bs,
      total: 0,
      perPage: 0,
      agreements: [],
      advSearchParams: [],
    }
  },
  watch: {
    $route(to, from){
      this.loadAgreements();
    }
  },
  created(){
    this.$store.dispatch('setnewAgreementData', {});
    this.loadAgreements()
  },
  methods: {
    loadAgreements(){
      let queryP = {}
      if(Object.keys(this.advSParams).length > 0){
        queryP["as"] = true
        let searchParams = prepareAgreementSearchParams(this.advSParams);
        for(let key in searchParams){
          queryP[key] = searchParams[key];
        }
        this.advSearchParams = queryP
      }
      if (this.advSearchParams.length > 0){
        paramsFromQuery(queryP, this.advSearchParams);
      }
      else{
        paramsFromQuery(queryP, this.$route.query);
      }
      let data = this.$axios.get('/mobile_crm/agreements', {
        params: queryP
      })
      .then(res=>{
        this.agreements = res.data.agreements;
        this.perPage = res.data.per_page;
        this.total = res.data.count;
        // this.$store.dispatch('setAdvSParams', {});
    })
    .catch(err => console.log(err));
    },
    goToPage(pageNo){
      let newQ = {...this.$route.query, pageNo};
      this.$router.replace({query: newQ});
    },
    resetBs(){
      let rQ = this.$route.query
      this.bsTerm = ''
      if(rQ.bs){
        let {bs, ...newQ} = {}
        this.$router.replace({query: newQ})
      }
    },
    performBs(){
      if(this.bsTerm){
        let newQ = {...this.$route.query, bs: this.bsTerm}
        delete newQ.pageNo
        this.$router.replace({query: newQ})
      }
    }
  },
  computed: {
    advSParams(){
      return this.$store.getters.advSParams;
    },
    totalPages(){
      if(this.total === 0 || this.perPage === 0){
        return 0;
      }else{
        return Math.ceil(this.total/this.perPage);
      }
    },
    pageNo: {
      get(){
        let pageNo = this.$route.query.pageNo || 1
        return parseInt(pageNo);
      },
      set(){
        true;
      }
    },
    pageStart(){
      if(this.total === 0){
        return 0;
      }
      return (Math.max(0, (this.pageNo - 1)*this.perPage+1))
    },
    pageEnd(){
      if(this.total === 0){
        return 0;
      }
      return (Math.min(this.total, this.pageNo*this.perPage))
    }
  }
}
</script>
<style scoped>

</style>
